import React from "react";
import landingComputador from '../../assets/landing-computador.png';
import landingTablet from '../../assets/landing-tablet.png';

export default function SealSection() {
  return (
    <div className="flex flex-col justify-center items-center px-4 py-12 text-cyan-950 max-w-screen-xl mx-auto">
      <h2 className="text-center text-2xl md:text-3xl font-bold mb-8">
        O que é o karma?
      </h2>

      
      <div className="flex flex-col md:flex-row flex-wrap gap-6 items-center justify-center text-stone-900 w-full mb-8">
        <div className="text-lg w-full md:w-[410px]">
          Objetivo da moeda social karma: valorizar{" "}
          <span className="font-bold text-cyan-950">boas ações</span>,
          potencializando o engajamento socioambiental em prol do
          desenvolvimento sustentável.
          <br />
          <br />
          Ao ver o{" "}
          <span className="font-bold text-cyan-950">Selo karma</span>, você sabe
          que está em um local que valoriza o{" "}
          <span className="font-bold text-cyan-950">impacto positivo</span> e
          que faz parte de um movimento para espalhar o bem.
        </div>

        <img
          loading="lazy"
          srcSet="https://cdn.builder.io/api/v1/image/assets/103790acd32d40c0b511bf41726fd638/497342408a2d8d33a770a5ad409287f407fd276708d7b4eb61831aa4eeb31004?apiKey=103790acd32d40c0b511bf41726fd638&"
          alt="Imagem ilustrativa"
          className="object-contain rounded-[123px] min-w-[240px]
               w-full max-w-[245px] aspect-[0.98]"
        />
      </div>
      <div className="flex flex-row justify-center items-center w-full text-cyan-950">
        <img
          loading="lazy"
          srcSet={landingComputador}
          className="w-24 sm:w-full md:w-auto h-48 -rotate-[10deg] mr-8"
          alt="Imagem computador"
        />
        <img
          loading="lazy"
          srcSet={landingTablet}
          className="w-24 sm:w-full md:w-auto h-48 rotate-[10deg] mr-10 "
          alt="Imagem tablet"
        />
        <div className="text-center md:text-left text-lg md:text-xl font-semibold  ">
          Participe e seja parte<br/> dessa economia de <br/>boas ações!
        </div>
      </div>
    </div>
  );
}
